export default __webpack_public_path__ + "static/media/matthew.cb0787d1.png";